import PropTypes from "prop-types";
import { getTranslation } from "../../../_utils/translator";

export const translate = (t, values) => getTranslation(t, values);
// export const translateBySuffix = (baseKey, suffix, values) => getTranslationBySuffix(baseKey, suffix, values);

const Trans = ({ t, values }) => getTranslation(t, values);

Trans.propTypes = {
  t: PropTypes.string.isRequired,
  values: PropTypes.shape({
    [PropTypes.string]: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
};

Trans.defaultProps = {
  values: {},
};

export default Trans;
